import { memoize } from 'lodash';

/**
 * Registers the service worker for notifications.
 *
 * @param {string} serviceWorkerPath the path to the service worker
 * @returns {Promise<ServiceWorkerRegistration>} the registration promise
 */
export const registerServiceWorker = memoize(async (serviceWorkerPath) => {
    if (!serviceWorkerPath) throw new Error('Service worker path is required.');

    const registration = navigator.serviceWorker.register(serviceWorkerPath, {
        scope: '/',
    });
    await navigator.serviceWorker.ready;
    return registration;
});
